<template>
  <div>
    <v-row class="mt-10 justify-center">
      <v-flex lg10 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1 text-left">
          샵플러스 이용약관
        </p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <v-textarea outlined no-resize hide-details="false"></v-textarea>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <v-checkbox v-model="selected" label="이용약관 내용에 동의합니다." value="useAgree" class="mt-0"></v-checkbox>
      </v-flex>
    </v-row>

    <v-row class="mt-10 justify-center">
      <v-flex lg10 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-0 text-left">
          샵플러스 개인정보처리방침
        </p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <v-textarea outlined no-resize hide-details="false" class="mt-0"></v-textarea>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <v-checkbox v-model="selected" label="개인정보처리방침을 확인하였습니다." value="privacyPolicyAgree" class="mt-0"></v-checkbox>
      </v-flex>
    </v-row>

    <v-row class="mt-10 justify-center">
      <v-flex lg10 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-0 text-left">
          개인정보 수집 및 이용안내
        </p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <v-textarea outlined no-resize hide-details="false" class="mt-0"></v-textarea>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <v-checkbox
          v-model="selected"
          label="개인정보 수집 및 이용내역에 동의합니다."
          value="PersonalInfoCollectionAgree"
          class="mt-0"
        ></v-checkbox>
      </v-flex>
    </v-row>

    <v-row class="justify-center mt-10">
      <v-flex lg10 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1 text-left">가입 정보</p>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <div class="col-4 pl-0 pt-0 pb-0 pr-2" style="float:left">
          <v-text-field outlined label="아이디 입력" dense hide-details="false" v-model="mallId"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-0 pr-2" style="float:left">
          <v-text-field
            outlined
            label="비밀번호 입력"
            dense
            hide-details="false"
            v-model="mallPassword"
            :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passwordShow ? 'text' : 'password'"
            @click:append="passwordShow = !passwordShow"
          ></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-2 pr-0" style="float:left">
          <v-text-field
            outlined
            label="비밀번호 확인 입력"
            dense
            hide-details="false"
            v-model="mallPasswordConfirm"
            :append-icon="passwordConfirmShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passwordConfirmShow ? 'text' : 'password'"
            @click:append="passwordConfirmShow = !passwordConfirmShow"
          ></v-text-field>
        </div>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg10 md4 sm10 xs10>
        <p class="subtitle-2 mb-1 grey--text text--lighten-1 text-left">
          - 비밀번호는 영문+숫자+특수문자를 조합하여 8자 이상 필수입니다.
        </p>
      </v-flex>
    </v-row>

    <v-row class="justify-center mt-10">
      <v-flex lg10 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1 text-left">쇼핑몰 정보</p>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <div class="col-4 pl-0 pt-0 pb-2 pr-2" style="float:left">
          <v-text-field outlined label="사업자등록증 상호명" dense hide-details="false" v-model="companyName"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-2 pr-2" style="float:left">
          <v-text-field outlined label="사업자번호" dense hide-details="false" v-model="businessLicenseNumber"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-2 pr-0" style="float:left">
          <v-text-field outlined label="쇼핑몰명" dense hide-details="false" v-model="mallName"></v-text-field>
        </div>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <div class="col-4 pl-0 pt-0 pb-0 pr-2" style="float:left">
          <v-text-field outlined label="쇼핑몰 대표 이메일" dense hide-details="false" v-model="mallEmail"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-0 pr-2" style="float:left">
          <v-text-field outlined label="쇼핑몰 URL 주소" dense hide-details="false" v-model="mallUrl"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-0 pr-0" style="float:left">
          <v-select
            v-model="selectedModal"
            :items="selectedItems"
            item-text="text"
            item-value="value"
            label="선택하세요."
            outlined
            dense
            single-line
          ></v-select>
        </div>
      </v-flex>
    </v-row>

    <v-row class="justify-center mt-10">
      <v-flex lg10 md4 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1 text-left">담당자 정보</p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg10 sm10 xs10>
        <div class="col-4 pl-0 pt-0 pb-0 pr-2" style="float:left">
          <v-text-field outlined label="담당자명" dense hide-details="false" v-model="mallManagerName"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-0 pr-2" style="float:left">
          <v-text-field outlined label="담당자 휴대폰" dense hide-details="false" v-model="mallManagerHp"></v-text-field>
        </div>
        <div class="col-4 pl-2 pt-0 pb-0 pr-0" style="float:left">
          <v-text-field outlined label="담당자 이메일" dense hide-details="false" v-model="mallManagerEmail"></v-text-field>
        </div>
      </v-flex>
    </v-row>

    <v-row class="mb-10 mt-10 justify-center">
      <v-flex lg10 md4 sm10 xs10>
        <v-btn color="primary" class="col-12" height="42" @click="serviceSignUpApply" :disabled="serviceSignUpApplyDisabled"
          >서비스 가입 신청하기</v-btn
        >
      </v-flex>
    </v-row>

    <Alert ref="Alert"></Alert>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Alert from "@/components/common/Alert.vue";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data() {
    return {
      M,
      selected: [],
      selectedModal: { text: "선택하세요.", value: "0" },
      selectedItems: [
        { text: "선택하세요.", value: "0" },
        { text: "자체 솔루션 / 기타", value: "1" },
      ],
      mallId: "",
      mallPassword: "",
      mallPasswordConfirm: "",
      companyName: "",
      businessLicenseNumber: "",
      mallName: "",
      mallEmail: "",
      mallUrl: "",
      solution_name: "",
      mallManagerName: "",
      mallManagerHp: "",
      mallManagerEmail: "",
      serviceSignUpApplyDisabled: false,
      passwordShow: false,
      passwordConfirmShow: false,
    };
  },
  mixins: [CommonMixin],
  methods: {
    serviceSignUpApply: async function() {
      if (this.selectedModal.value == 0) {
        this.selectedModal = 0;
      }
      if (this.selected.length < 3) {
        this.alertShow("이용약관 / 개인정보취급방침 / 이용안내<br>내역을 확인하시고 체크해주세요.");
        return false;
      }

      if (
        !this.mallId ||
        !this.mallPassword ||
        !this.mallPasswordConfirm ||
        !this.companyName ||
        !this.businessLicenseNumber ||
        !this.mallName ||
        !this.mallEmail ||
        !this.mallUrl ||
        !this.mallManagerName ||
        !this.mallManagerHp ||
        !this.mallManagerEmail ||
        this.selectedModal < 1
      ) {
        this.alertShow("입력하지 않은 정보가 있습니다.<br>입력 후 가입 신청을 해주세요.");
        return false;
      }

      if (this.selectedModal == 1) {
        this.solution_name = "자체 솔루션 / 기타";
      }

      let passwordCheckResult = this.passwordCheck();
      if (passwordCheckResult === false) {
        return false;
      }

      try {
        let result = await M.api(M.entry("/users/signup"), {
          mall_id: this.mallId,
          mall_name: this.mallName,
          password: this.mallPassword,
          business_name: this.companyName,
          business_number: this.businessLicenseNumber,
          mall_email: this.mallEmail,
          mall_url: this.mallUrl,
          solution_name: this.solution_name,
          manager_name: this.mallManagerName,
          manager_phone: this.mallManagerHp,
          manager_email: this.mallManagerEmail,
        });

        if (result.mall_id) {
          this.alertShow("신청이 완료되었습니다.<br>담당자 확인 후 2영업일 내로 연락드리겠습니다.<br>감사합니다.");

          this.serviceSignUpApplyDisabled = true;
        } else {
          this.alertShow("신청이 실패되었습니다.");
        }
      } catch (e) {
        this.alertShow("신청이 실패되었습니다.");
      }
    },
    passwordCheck: function() {
      if (this.mallPassword != this.mallPasswordConfirm) {
        this.alertShow("비밀번호를 확인해주세요");
        return false;
      }

      let num = this.mallPassword.search(/[0-9]/g);
      let eng = this.mallPassword.search(/[a-z]/gi);
      let spe = this.mallPassword.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);

      if (this.mallPassword.length < 8 || this.mallPassword.length > 20) {
        this.alertShow("8자리 ~ 20자리 이내로 입력해주세요.");
        return false;
      } else if (this.mallPassword.search(/\s/) != -1) {
        this.alertShow("비밀번호는 공백 없이 입력해주세요.");
        return false;
      } else if (num < 0 || eng < 0 || spe < 0) {
        this.alertShow("영문,숫자, 특수문자를 혼합하여 입력해주세요.");
        return false;
      } else {
        return true;
      }
    },
  },
  components: {
    Alert,
  },
};
</script>
